import { render, staticRenderFns } from "./NaviListResident.vue?vue&type=template&id=4193709a&"
import script from "./NaviListResident.vue?vue&type=script&lang=js&"
export * from "./NaviListResident.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports